<template>
	 <div class="bodybox" >
        <div class="tablehead">
            <p>活动名称:<span>{{groupinfo.group_name}}</span></p>
            <p>活动时间:<span>{{groupinfo.start_time}}至{{groupinfo.end_time}}</span></p>
            <p>购买数量:<span>{{groupinfo.order_sum}}</span></p>
        </div>

        <table class="table table-bordered table-hover" v-loading="loading2" style="font-size: 14px;">
            <thead>
            <tr>
                <th>序号</th>
                <th>岗位</th>
                <th>姓名</th>
                <th>是否测评师</th>
                <th>人数</th>
                <th>应结金额</th>
                <th>结算状态</th>
                <th>操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="status">
                <td>暂无数据</td>
            </tr>
            <tr v-if="!status" v-for="(ta,index) in tabdata">
                <td>{{index+1}}</td>
                <td>{{ta.gangwei}}</td>
                <td>{{ta.username}}</td>
                <td>{{ta.cpteacher}}</td>
                <td>{{ta.person_count}}</td>
                <td>{{ta.settlement_money}}</td>
                <td>{{ta.status}}</td>
                <td style="color: #0099FF">
                	<span v-if="ta.status=='未结算'" style="cursor: pointer"
                     @click="jiesuan(ta.user_id,ta.cp_teacher,ta.person_count,ta.settlement_money)">结算</span>
                </td>
            </tr>
            </tbody>
        </table>

        <el-dialog
            class="tanchuang"
            title="结算"
            :visible.sync="dialogVisible"
            width="40%"
        	:close-on-click-modal="false">
            <span>是否进行结算</span>
            <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="success" @click="quejiesuan">确 定</el-button>
		  </span>
        </el-dialog>
    </div>
</template>

<script>
	export default{
		data(){
			return{
				loading2: false,
	            tabdata: '',
	            center: '',
	            aid: '',
	            dialogVisible: false,
	            groupinfo: "",
	            user_id: '',
	            cp_teacher: '',
	            person_count: '',
	            settlement_money: '',
	            create_user: '',
	            status:'',
                token:''
			}
		},
		methods: {
            jiesuan: function (user_id, cp_teacher, person_count, settlement_money) {
                let self = this;
                self.dialogVisible = true;
                self.user_id = user_id;
                self.cp_teacher = cp_teacher;
                self.person_count = person_count;
                self.settlement_money = settlement_money;
            },
            quejiesuan: function () {
                let self = this;
                $.ajax({
                    type: 'POST',
                    url: process.env.apiUrl + "saas/settlement/do_staff_settlement",
                    data: {
                        user_id: self.user_id,
                        group_id: self.aid,
                        cp_teacher: self.cp_teacher,
                        person_count: self.person_count,
                        settlement_money: self.settlement_money,
                        token: self.token,
                    },
//                  beforeSend: function(xhr) {
//                        self.loading2=true
//                  },
                    success: function (data) {
                        if (data.status == 1) {
                            self.dialogVisible = false;

                            $.ajax({
                                type: 'POST',
                                url: process.env.apiUrl + "saas/settlement/staff_details",
                                data: {
                                    token:self.token,
                                    group_id: self.aid
                                },
                                beforeSend: function (xhr) {
                                    self.loading2 = true
                                },
                                success: function (data) {
                                    self.loading2 = false;

                                    if (data.status == 2) {
                                        self.status = true;
                                        self.groupinfo = data.groupinfo;

                                    } else {
                                        self.status = false
                                        self.tabdata = data.data;
                                        self.groupinfo = data.groupinfo;
                                    }
                                },
                                error: function (data) {
                                    self.$message.error(`请求失败!`);
                                }
                            });

                        } else if (data.status == 3) {
                            self.$message.error(`${data.msg}`);
                        } else {
                            self.$message.error(`结算失败!`);
                        }

                    },
                    error: function (data) {
                        self.$message.error(`结算请求失败!`);
                    }
                });
            }
        },
        mounted: function () {
//          $.cookie('centre_id','223')
//          $.cookie('create_user','1')
            let self = this;
            self.create_user = $.cookie('create_user');
            self.centre_id = $.cookie('centre_id');
            self.token = $.cookie('token');


            self.aid = this.$route.query.aid;

            $.ajax({
                type: 'POST',
                url: process.env.apiUrl + "saas/settlement/staff_details",
                data: {
                    token:self.token,
                    group_id: self.aid
                },
                beforeSend: function (xhr) {
                    self.loading2 = true
                },
                success: function (data) {
                    console.log(data);
                    self.loading2 = false;

                    if (data.status == 2) {
                        self.status = true;
                        self.groupinfo = data.groupinfo;
                    } else {
                        self.status = false;
                        self.tabdata = data.data;
                        self.groupinfo = data.groupinfo;
                    }
                },
                error: function (data) {
                    self.$message.error(`请求失败!`);
                }
            });
        }
	}
</script>

<style scoped="scoped">
	/*重置element样式*/
	.el-dialog__wrapper{
		position: relative;
	}


	* {
        margin: 0;
    }

    .bodybox {
        padding: 10px;
    }

    .headerBox {
        display: flex;
        display: -webkit-flex;
        line-height: 32px;
        margin-bottom: 20px;

    }

    .btngroup .el-radio__input {
        display: none;
    }

    .btngroup {
        margin-right: 50px;
    }

    .tablehead {
        display: flex;
        display: -webkit-flex;
        line-height: 50px;
        height: 50px;

    }

    .tablehead p {
        padding-left: 10px;
        padding-right: 20px;
        font-size: 16px;
    }

    .tablehead p span {
        padding-left: 5px;
        color: #999;
    }
</style>



// WEBPACK FOOTER //
// src/pages/ceping/yewujiesuan2.vue